import React, { useState, useEffect, useMemo } from 'react';
import { Row, Col, Card, CardBody, Container, Spinner } from 'reactstrap';
import * as affiliateActions from '../../store/affiliates/actions';
import * as userActions from '../../store/users/actions';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../components/Common/Modal/Modal';
import FormAffiliate from '../../components/Affiliates/FormAffiliate';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DataTableNext from '../../components/Common/DataTable/DataTableNext';
import createTableColumns from '../../components/Affiliates/tableColumns';
import ShowSingleElement from '../../components/Common/ShowSingleElement';
import {
  ExportButtonPlacement,
  ToggleColumnButton,
  CreateButton,
} from '../../components/Common/DataTable/tableActionButtons';
import { addOrRemove } from '../../helpers/sharedFunction';
import LinkGenerator from '../../components/Affiliates/LinkGenerator';

const List = () => {
  const loading = useSelector((state) => state.Affiliate.loading);
  const affiliates = useSelector((state) => state.Affiliate.affiliates);
  const error = useSelector((state) => state.Affiliate.error);
  const user = useSelector((state) => state.Auth.admin);

  const [viewModal, setViewModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [linkGeneratorModal, setLinkGeneratorModal] = useState(false);
  const [selectedAffiliate, setSelectedAffiliate] = useState(null);

  const [filters, setFilters] = useState([]);
  const [sorting, setSorting] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(affiliateActions.syncAffiliates());
    dispatch(userActions.syncUsers());
  }, []);

  const openEditModal = (affiliate = null) => {
    setSelectedAffiliate(affiliate);
    setEditModal(true);
  };

  const openViewModal = (affiliate) => {
    setSelectedAffiliate(affiliate);
    setViewModal(true);
  };

  const openLinkGeneratorModal = (affiliate) => {
    setSelectedAffiliate(affiliate);
    setLinkGeneratorModal(true);
  };

  const columns = useMemo(
    () =>
      createTableColumns(
        openViewModal,
        openEditModal,
        user,
        openLinkGeneratorModal,
      ),
    [user],
  );
  const [hiddenColumns, setHiddenColumns] = useState(
    columns.filter(({ hidden }) => !!hidden).map(({ name }) => name),
  );
  const handleToggleColumn = (name) => {
    setHiddenColumns(addOrRemove(hiddenColumns, name));
  };

  // Inserisci qui eventuali colonne custom extra (es: azioni)
  // oppure aggiungile direttamente in createTableColumns se vuoi la massima uniformità

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Affiliates" />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="align-items-center justify-content-end mb-2">
                    <Spinner
                      color="secondary"
                      animation="border"
                      hidden={!loading}
                    />
                    <CreateButton
                      label="Nuovo Affiliato"
                      disabled={loading}
                      onPress={() => openEditModal(null)}
                    />
                    <ToggleColumnButton
                      columns={columns}
                      hiddenColumns={hiddenColumns}
                      onToggleColumn={handleToggleColumn}
                    />
                    <ExportButtonPlacement />
                  </Row>
                  <DataTableNext
                    loading={loading}
                    rows={affiliates}
                    columns={columns}
                    filters={filters}
                    onFiltersChange={setFilters}
                    sorting={sorting}
                    onSortingChange={setSorting}
                    currentPage={currentPage}
                    onCurrentPageChange={setCurrentPage}
                    hiddenColumns={hiddenColumns}
                    onHiddenColumnsChange={setHiddenColumns}
                    pageSize={pageSize}
                    onPageSizeChange={setPageSize}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal
            size="lg"
            title="User"
            isOpen={viewModal}
            toggle={() => setViewModal(!viewModal)}
            showClose
            scrollable={false}>
            <ShowSingleElement
              element={selectedAffiliate}
              collection="affiliates"
            />
          </Modal>
          <Modal
            size="xl"
            title="Affiliato"
            isOpen={editModal}
            toggle={() => setEditModal(!editModal)}
            scrollable={false}>
            <FormAffiliate
              closeModal={() => setEditModal(false)}
              create={!selectedAffiliate}
              loading={loading}
              affiliate={selectedAffiliate}
              affiliates={affiliates}
            />
          </Modal>
          <Modal
            size="md"
            title="Genera Link Affiliazione"
            isOpen={linkGeneratorModal}
            toggle={() => setLinkGeneratorModal(false)}
            showClose
            scrollable={false}>
            <LinkGenerator affiliate={selectedAffiliate} />
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default List;
